import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Format tool names for display
 * Examples:
 * - "mcp__1__gaql_query" → "GAQL Query"
 * - "mcp__context7__get-library-docs" → "Get Library Docs"
 * - "simple_tool" → "Simple Tool"
 */
export function formatToolName(toolName: string): string {
	// Remove mcp__ prefix and numeric prefixes
	let formatted = toolName.replace(/^mcp__\d+__/i, "").replace(/^mcp__/i, "");

	// Replace underscores and hyphens with spaces
	formatted = formatted.replace(/[_-]/g, " ");

	// Convert to Title Case
	formatted = formatted
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");

	return formatted;
}
